import { Component } from '@angular/core';

@Component({
  selector: 'zip-card',
  templateUrl: './zip-card.component.html',
})
export class ZipCardComponent {}
